import React, { memo, useMemo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { VIEWER_SIDEBAR_TAB } from 'Pods/ThreeDStudio/Store/constants'

import AnimateTab from './Components/AnimateTab/AnimateTab'
import AssistTab from './Components/AssistTab/AssistTab'
import RemeshTab from './Components/RemeshTab/RemeshTab'
import RenderTab from './Components/RenderTab/RenderTab'
import SegmentTab from './Components/SegmentTab/SegmentTab'
import TextureTab from './Components/TextureTab/TextureTab'
import VariationsTab from './Components/VariationsTab/VariationsTab'

function EnhanceModelPanel({ isOpen }) {
  const activeViewerSidebarTab = useThreeDStudioStore(state => state.ui?.activeViewerSidebarTab)
  // While a model file is uploading there is no model to enhance yet, so lock
  // every tab's fields. A native <fieldset disabled> disables all nested form
  // controls and drops them from the tab order, covering current and future tabs
  // without per-field wiring.
  const isModelUploading = useThreeDStudioStore(state => state.ui?.isModelUploading)

  const renderContent = useMemo(() => {
    switch (activeViewerSidebarTab) {
      case VIEWER_SIDEBAR_TAB.REMESH:
        return <RemeshTab />
      case VIEWER_SIDEBAR_TAB.TEXTURE:
        return <TextureTab />
      case VIEWER_SIDEBAR_TAB.SEGMENT:
        return <SegmentTab />
      case VIEWER_SIDEBAR_TAB.ANIMATE:
        return <AnimateTab />
      case VIEWER_SIDEBAR_TAB.RENDER:
        return <RenderTab />
      case VIEWER_SIDEBAR_TAB.VARIATIONS:
        return <VariationsTab />
      case VIEWER_SIDEBAR_TAB.ASSIST:
        return <AssistTab />
      default:
        return null
    }
  }, [activeViewerSidebarTab])

  return (
    <div className={classnames(
      'enhance-model-panel',
      isOpen && 'enhance-model-panel--opened',
    )}>
      <fieldset
        className={classnames(
          'enhance-model-panel__content',
          isModelUploading && 'enhance-model-panel__content--disabled',
        )}
        disabled={isModelUploading}
      >
        {renderContent}
      </fieldset>
    </div>
  )
}

EnhanceModelPanel.propTypes = {
  isOpen: bool.isRequired,
}

export default memo(EnhanceModelPanel)
